// Extracts error message from various error object shapes
function extractErrorMessage(error: any): string {
  return (
    error?.response?.data?.message || error?.response?.data?.error?.message || error?.message || ""
  );
}

// Maps Twilio error messages to user-friendly messages
export function getFriendlyTwilioErrorMessage(error: any): string {
  const backendMessage = extractErrorMessage(error);

  if (typeof backendMessage !== "string" || !backendMessage) {
    return "Failed to send SMS. Please try again or contact support if the problem persists.";
  }

  const message = backendMessage.toLowerCase();

  // Region/permission errors
  if (
    message.includes("permission to send an sms has not been enabled") ||
    message.includes("region indicated by")
  ) {
    return "SMS is not available for this phone number's region. Please contact support to enable SMS for this region.";
  }

  // Invalid phone number errors
  if (
    message.includes("invalid") &&
    (message.includes("phone") || message.includes("number") || message.includes("to"))
  ) {
    return "Invalid phone number. Please check the number and try again.";
  }

  // Rate limit errors
  if (message.includes("rate limit") || message.includes("too many")) {
    return "Too many SMS messages sent. Please wait a moment and try again.";
  }

  // Account/credential errors
  if (
    message.includes("account") ||
    message.includes("credential") ||
    message.includes("authentication")
  ) {
    return "SMS service configuration error. Please contact support.";
  }

  // Character limit errors
  if (message.includes("character") || message.includes("length") || message.includes("limit")) {
    return "Message is too long. Please shorten your message and try again.";
  }

  // Service unavailable errors
  if (
    message.includes("tunnel unavailable") ||
    message.includes("service unavailable") ||
    message.includes("temporarily unavailable")
  ) {
    return "SMS service is temporarily unavailable. Please try again in a few moments.";
  }

  // Network/connection errors
  if (
    message.includes("network") ||
    message.includes("connection") ||
    message.includes("timeout")
  ) {
    return "Network error. Please check your connection and try again.";
  }

  // Default user-friendly message
  return "Failed to send SMS. Please try again or contact support if the problem persists.";
}
